/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_ResentInputs */

const he_auth_otp_resent = /** @type {(inputs: Auth_Otp_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הקוד נשלח מחדש`)
};

const en_auth_otp_resent = /** @type {(inputs: Auth_Otp_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code resent`)
};

/**
* | output |
* | --- |
* | "Code resent" |
*
* @param {Auth_Otp_ResentInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_resent = /** @type {((inputs?: Auth_Otp_ResentInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_ResentInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_resent(inputs)
	return en_auth_otp_resent(inputs)
});